import React from "react";
import Stepper from "./Stepper/Stepper";

const InputStepper = ({
  min,
  max,
  value,
  onChange,
  description = "",
  label,
  error,
}) => {
  const onIncrease = (e) => {
    e.stopPropagation();
    onChange(value + 1);
  };

  const onDecrease = (e) => {
    e.stopPropagation();
    if (Boolean(value)) {
      onChange(value - 1);
    }
  };

  return (
    <div className="flex items-center justify-between">
      <div className="select-none">
        <span className="font-mulish block text-16-24">{label}</span>
        <span className="font-mulish text-gray-text-2 text-14-20 opacity-80">
          {description}
        </span>
      </div>
      <div>
        <Stepper
          error={error}
          max={max}
          min={min}
          value={value}
          onIncrease={onIncrease}
          onDecrease={onDecrease}
        />
      </div>
    </div>
  );
};

export default InputStepper;
